import useMediaQuery from '@mui/material/useMediaQuery';
import { ReactNode } from 'react';

import DesktopLayout from './components/DesktopLayout';
import MobileLayout from './components/MobileLayout';

export type OrderHubProps = { children: ReactNode };

function OrderHub({ children }: OrderHubProps) {
  const mobile = useMediaQuery('(min-width:600px)');

  const Layout = mobile ? DesktopLayout : MobileLayout;

  return <Layout>{children}</Layout>;
}

export default OrderHub;
